import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { GoogleMapsProvider, loadGoogleMaps } from '~/components/AddressAutocomplete';
import { useQboInVob } from '~/components/VendorOnboardingModal/useQboInVob';
import VendorOnboardingModal from '~/components/VendorOnboardingModal/VendorOnboardingModal';
import { useEventReporter } from '~/event-reporter';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useStore, useStoreActions } from '~/store/store-context';
// Exported handler function that can be used directly when feature flag is enabled
export const handleCreateVendorAccountApprove = async (userInfo, api, logBI, reportToHeap, reportToHubspot)=>{
    logBI(18101);
    reportToHubspot('create_vendor_account_approve_v4');
    reportToHeap('top-bar', 'click', 'client-create-vendor-account-approve');
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasApprovedTermsOfService())) {
        const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
        if (userId) {
            await api.auth.approveTos(userId);
        }
    }
};
export const useCreateVendorAccount = (onClick)=>{
    const userInfo = useStore((state)=>state.userInfo);
    const { SP_ONBOARDING_PHASE_1 } = useFeatureFlags();
    const { setWorksAt, api, logBI } = useStoreActions();
    const { reportToHeap, reportToHubspot } = useEventReporter();
    const overlayContext = useOverlayContext();
    const showQboStep = useQboInVob();
    const onCreateVendorAccount = async ()=>{
        onClick === null || onClick === void 0 ? void 0 : onClick();
        reportToHubspot('create_vendor_account_clicked_v2');
        reportToHeap('top-bar', 'click', 'client-create-vendor-account-topbar');
        await handleCreateVendorAccountApprove(userInfo, api, logBI, reportToHeap, reportToHubspot);
        setWorksAt();
        // When SP_ONBOARDING_PHASE_1 is on, HomePage's onboarding effect detects the cleared
        // worksAt and opens V2 with the correct mode (clientToVendor / additionalAccount based on
        // user state). We intentionally do not open V1 here in that case.
        if (SP_ONBOARDING_PHASE_1) return;
        await overlayContext.showModal({
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(GoogleMapsProvider, {
                    loadGoogleMaps: loadGoogleMaps,
                    children: /*#__PURE__*/ _jsx(VendorOnboardingModal, {
                        dismissModal: dismissModal,
                        showQboStep: !!showQboStep
                    })
                });
            },
            closeOnClickOutside: false,
            shouldBlurBackground: true,
            biName: 'vendor_onboarding_modal'
        });
    };
    return onCreateVendorAccount;
};
